import React from "react";
import { ExchangeSubmitted } from "../Components";

export const ExchangeSubmittedPage = () => {
  return <ExchangeSubmitted />;
};
